import React from "react";
import {withStyles} from "@material-ui/core/styles";
import {withRouter} from "react-router-dom";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {withWidth} from "@material-ui/core";

import {
    USER_TYPE_ADMIN, USER_TYPE_SUPER_ADMIN, USER_TYPE_CLIENT, USER_TYPE_REPAIRER, WAITING_FOR_REPLY
} from "../../../../constants/constants";
import {connect} from "react-redux";
import EditIcon from "@material-ui/icons/Edit";
import {ACCORDION_B} from "./InfoForm";
import countries from "i18n-iso-countries";
import CustomInlineSvg from "../../../../theme/CustomElements/CustomInlineSvg";
import copyIcon from "../../../../images/request/copy-icon.svg";
import PopoverAlertTooltip from "../../../../theme/CustomElements/PopoverAlertTooltip";
import PropTypes from "prop-types";
import {dataCopyAllInterventionInformation} from "../constantRequestPage";

const styles = theme => ({
    infoSummary: {
        'text-align': 'left',
        margin: 'auto',
        maxWidth: '9£0%',
        '& h3': {
            display: 'flex',
        },
        '& *': {
            maxWidth: '100%'
        },
        '& .identity': {
            'display': 'inline-block',
        },
        '& .bold': {
            fontWeight: 'bold'
        },
        '& .userInfo-container *': {
            cursor: 'pointer',
            width: 'max-content'
        },
        '& .addressInfo-container': {
            position: 'relative',
            '& .popoverAlertAndButtonCustom': {
                position: 'absolute',
                top: -35,
                left: 10,
                '& .popoverAlertText':{
                    position: 'relative',
                    left: 0
                }
            }
        },
        '& .addressInfo-container *': {
            cursor: 'pointer',
            width: 'max-content',
        },
        '& .addressInfo-billingAddress-container *': {
            cursor: 'pointer',
            width: 'max-content'
        },
        '& .complemenataryInfo-container *': {
            cursor: 'pointer',
            width: 'max-content'
        },

        '& .info-row': {
            display: 'flex',
            '& > div.label': {
                marginRight: 6,
                height: 'fit-content',
            }
        },
        '& .copy-row': {
            cursor: 'pointer',
            '&:hover': {
                '-webkit-text-stroke': '0.1px #000'
            }
        }
    },
    actionEditSubject: {
        width: 'fit-content',
        alignItems: 'center',
        display: 'flex',
        '& > div': {
            '&.btnSave, &.btnCopy': {
                '& svg': {
                    color: '#0022ff'
                }
            },
            padding: 3,
            borderRadius: 5,
            marginLeft: 5,
            height: 30,
            width: 30,
            cursor: 'pointer',
            '&:hover': {
                background: 'rgba(0,0,0,0.1)'
            }
        },

        '&.btnCopyAllCollapse': {
            width: 34,
            display: 'block',
            height: 30,
            '& .btnCopy': {
                padding: 3,
                height: 30,
                width: 30
            },
        }
    }
})

class AdminInfoSummary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            copied: false,
            copiedRow: false
        }
    }


    renderShowButtonEditByTitle = (title) => {
        const {classes, groupBaseUser, valueForm} = this.props;
        const canEditValue = [USER_TYPE_ADMIN, USER_TYPE_SUPER_ADMIN, USER_TYPE_REPAIRER].includes(groupBaseUser) ||
            (groupBaseUser === USER_TYPE_CLIENT && (valueForm?.status?.statusType?.code) && valueForm.status.statusType.code === WAITING_FOR_REPLY && !(valueForm?.isAdminOrExpertCreated))
        return canEditValue ? <div className={`${classes.actionEditSubject} btnHiddenBtnEditSubject`}>
            <div className={"btnSave"}
                 onClick={() => this.props.handleEditValue(title)}>
                <EditIcon/>
            </div>
        </div> : ""
    }

    saveDataCopyInClipboard = () => {
        const {valueForm, t} = this.props;
        navigator.clipboard.writeText(dataCopyAllInterventionInformation(valueForm));
        this.setState({
            copied: true
        }, function () {
            setTimeout(() => {
                this.setState({
                    copied: false
                })
            }, 1000)
        })
    }

    buttonCopyCollapse = () => {
        const {classes, t} = this.props;

        return <div className={`${classes.actionEditSubject} btnCopyAllCollapse`}>
            <div className={`btnCopy`} onClick={() => this.saveDataCopyInClipboard()}>
                <CustomInlineSvg svgProps={{src: copyIcon}}/>
            </div>
            {this.state.copied && <PopoverAlertTooltip title={t('request.infoCopied')}/>}
        </div>
    }

    copyRow = (copyText) => {
        navigator.clipboard.writeText(copyText);
        this.setState({
            copiedRow: true
        }, function () {
            setTimeout(() => {
                this.setState({
                    copiedRow: false
                })
            }, 1000)
        })
    }

    render() {
        const {classes, t, valueForm, hiddenTitleRow} = this.props;
        const {copiedRow} =this.state

        const addressFullText = `${valueForm.addressDescription ?? ""} ${valueForm.addressPostalCode ? valueForm.addressPostalCode : ""}  ${valueForm.addressCity ? valueForm.addressCity : ""}  ${valueForm.addressCountry ? countries.getName(
            valueForm.addressCountry ?? "FR",
            this.props.t("translations.lang")) : ""}`

        let otherPhoneNumbersAddressText = "";
        const otherPhoneNumbersAddress = Array.isArray(valueForm?.otherPhoneNumbersAddress) ? valueForm.otherPhoneNumbersAddress.filter(item => item): [];
        otherPhoneNumbersAddress.forEach((item, index) => {
            otherPhoneNumbersAddressText += (index !== 0 && index < valueForm.otherPhoneNumbersAddress.length ? " " : "") + item
        })
        const isThereAnElevator_floorNumber = `${valueForm.isThereAnElevator === '0' ? "Pas d'" : 'Avec '}${t("information.formTab1.isThereAnElevator")}` + (valueForm.floorNumber ? `, ${t("information.formTab1.floorNumber")} ${parseInt(valueForm.floorNumber) === 0 ? 'RDC' : valueForm.floorNumber}` : '');
        return (
            <div className={classes.infoSummary}>
                {!hiddenTitleRow && <h3>{t("information.formTab1.labelAddressRepair")} {this.renderShowButtonEditByTitle(ACCORDION_B)} {this.buttonCopyCollapse()}</h3>}
                <div className={"addressInfo-container"}>
                    {!!copiedRow &&  <PopoverAlertTooltip title={t('request.copied')} hiddenArrow={true}/>}
                    <div
                        className={"addressInfo-name bold copy-row"}
                        onClick={() => this.copyRow(`${valueForm.addressFirstName} ${valueForm.addressLastName}`)}>
                        {`${valueForm.addressFirstName} ${valueForm.addressLastName}`}
                    </div>
                    {!!valueForm.addressCompany && <div className="info-row">
                        <div className={"label bold copy-row"} onClick={() => this.copyRow(`${valueForm.addressCompany}`)}>
                            {t("information.formTab1.company")} :
                        </div>
                        <div>
                            {valueForm.addressCompany ?? ""}
                        </div>
                    </div>}

                    {!!valueForm.companyTaxCode && <div className="info-row">
                        <div className={"label bold copy-row"} onClick={() => this.copyRow(`${valueForm.companyTaxCode}`)}>
                            {t("information.formTab1.company")} :
                        </div>
                        <div>
                            {valueForm.companyTaxCode ?? ""}
                        </div>
                    </div>}

                    <div className={"label bold copy-row"} onClick={() => this.copyRow(addressFullText)}>
                        {t("information.formTab1.addressInfo")} :
                    </div>
                    <div className={"addressInfo-description"}>
                        {valueForm.addressDescription ?? ""}
                    </div>
                    <div className={"addressInfo-full"}>
                        {valueForm.addressPostalCode ? `${valueForm.addressPostalCode} ` : ""}
                        {valueForm.addressCity ? `${valueForm.addressCity} ` : ""}
                        {countries.getName(
                            valueForm.addressCountry ?? "FR",
                            this.props.t("translations.lang"))}
                    </div>

                    {/*<div className={"addressInfo-description"}>{valueForm.addressDescription ?? ""}</div>*/}
                    {/*<div className={"addressInfo-full"}>*/}
                    {/*    <span>{valueForm.addressPostalCode ?? ""}</span> <span*/}
                    {/*>{valueForm.addressCity ?? ""}</span> <span*/}
                    {/*>{countries.getName(*/}
                    {/*    valueForm.addressCountry ?? "FR",*/}
                    {/*    this.props.t("translations.lang"))}</span>*/}
                    {/*</div>*/}

                    {!!valueForm.phoneNumberAddress && <div className="info-row">
                        <div className={"label bold copy-row"}
                             onClick={() => this.copyRow(`${valueForm.phoneNumberAddress}`)}>
                            {t("information.formTab1.phoneNumber")} :
                        </div>
                        <div>
                            {valueForm.phoneNumberAddress ?? ""}
                        </div>
                    </div>}

                    {!!(otherPhoneNumbersAddress.length) &&
                    <>
                        {otherPhoneNumbersAddress.map((itemPhoneOther, keyPhoneOther) => {
                            return (
                                <div className="info-row">
                                     <div className={"label bold copy-row"}
                                        onClick={() => this.copyRow(itemPhoneOther)}>
                                        {t("information.formTab1.otherPhoneNumber") + ` ${keyPhoneOther + 1}`} :
                                    </div>
                                    <div>
                                         {itemPhoneOther}
                                    </div>
                                </div>
                            )
                            })}
                    </>}

                    {!!valueForm.addressEmail && <div className="info-row">
                        <div className={"label bold copy-row"} onClick={() => this.copyRow(`${valueForm.addressEmail}`)}>
                            {t("information.formTab1.addressEmail")} :
                        </div>
                        <div>
                            {valueForm.addressEmail ?? ""}
                        </div>
                    </div>}

                    {!!valueForm.contractorEmail && <div className="info-row">
                        <div className={"label bold copy-row"} onClick={() => this.copyRow(`${valueForm.contractorEmail}`)}>
                            {t("information.formTab1.contractorEmail")} :
                        </div>
                        <div>
                            {valueForm.contractorEmail ?? ""}
                        </div>
                    </div>}

                    {/*{(!!(valueForm?.phoneNumberAddress) || (otherPhoneNumbersAddressText)) &&*/}
                    {/*<div className={"addressInfo-name bold copy-row"} onClick={() => this.copyRow(`${valueForm.phoneNumberAddress}`)}>*/}
                    {/*    {t("information.formTab1.phoneNumber")} :&#160;{valueForm.phoneNumberAddress ?? ""}{otherPhoneNumbersAddressText}*/}
                    {/*</div>}*/}
                    {/*{!!(valueForm?.addressEmail) && <div className={"addressInfo-name bold  copy-row"} onClick={() => this.copyRow(`${valueForm.addressEmail}`)}>*/}
                    {/*    {t("information.formTab1.addressEmail")} :&#160;{valueForm.addressEmail}*/}
                    {/*</div>}*/}
                    {/*{!!(valueForm?.contractorEmail) && <div className={"addressInfo-name bold copy-row"} onClick={() => this.copyRow(`${valueForm.contractorEmail}`)}>*/}
                    {/*    {t("information.formTab1.contractorEmail")} :&#160;{valueForm.contractorEmail}*/}
                    {/*</div>}*/}
                    {/*<div className={"addressInfo-floorNumber"}*/}
                    {/*     onClick={this.copyField}>{t("information.formTab1.floorNumber")} : {valueForm.floorNumber ?? ""}</div>*/}

                    <div className={"addressInfo-elevator bold  copy-row"}
                         onClick={() => this.copyRow(isThereAnElevator_floorNumber)}>
                        {isThereAnElevator_floorNumber}
                        {/*{valueForm.isThereAnElevator === '0' ? "Pas d'" : 'Avec '}{t("information.formTab1.isThereAnElevator")}{valueForm.floorNumber ? `, ${t("information.formTab1.floorNumber")} ${parseInt(valueForm.floorNumber) === 0 ? 'RDC' : valueForm.floorNumber}` : ''}*/}
                    </div>
                    {/*{valueForm.doorPassword !== "" && valueForm.doorPassword !== null &&*/}
                    {/*<div className={"addressInfo-doorPassword bold"}*/}
                    {/*>{t("information.formTab1.doorPassword")} : {valueForm.doorPassword !== "" && valueForm.doorPassword !== null ? valueForm.doorPassword : ""}</div>}*/}
                    {valueForm.doorPassword !== "" && valueForm.doorPassword !== null && <div className="info-row">
                        <div className={"label bold copy-row"} onClick={() => this.copyRow(`${valueForm.doorPassword}`)}>
                            {t("information.formTab1.doorPassword")} :
                        </div>
                        <div>
                            {valueForm.doorPassword !== "" && valueForm.doorPassword !== null ? valueForm.doorPassword : ""}
                        </div>
                    </div>}
                </div>
            </div>
        )
    }
}


PopoverAlertTooltip.defaultProps = {
    hiddenTitleRow: false
}

PopoverAlertTooltip.propTypes = {
    classes: PropTypes.object.isRequired,
    hiddenTitleRow: PropTypes.bool
}

const mapStateToProps = (state) => {
    return {
        groupBaseUser: state.authReducer.groupBaseUser,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {}
};
export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles),
    withTranslation(),
    withWidth(),
    withRouter
)(AdminInfoSummary);
